import { useCallback, useRef, useState } from 'react';

/**
 * Media URLs carry rotating short-lived tokens. Keep the element's src stable
 * for a representation so playback is not interrupted; adopt a fresh URL only
 * when the representation changes or the current one fails.
 */
export function useStableUrl(key: string | undefined, url: string | null): [string | null, () => boolean] {
  const [state, setState] = useState<{ key: string | undefined; url: string | null }>({ key, url });
  const latest = useRef(url);
  latest.current = url;
  if (state.key !== key) setState({ key, url });
  const refresh = useCallback(() => {
    if (latest.current && latest.current !== state.url) {
      setState({ key, url: latest.current });
      return true;
    }
    return false;
  }, [key, state.url]);
  return [state.key === key ? state.url : url, refresh];
}
